import Button from '@carvana/ds-button';
import { CircleAlert } from 'lucide-react';
import { icon } from '@carvana/ds-styles';
import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import { AlertModalContent } from '../AlertModalContent';

interface VinEtchingAlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  onButtonClick: () => void;
}

export const VinEtchingAlertModal: React.FC<VinEtchingAlertModalProps> = ({
  isOpen,
  onClose,
  onButtonClick
}) => {
  return (
    <EventedModal
      isOpen={isOpen}
      onClose={onClose}
      analyticsId={ModalNames.VinEtchingError}
      zIndex={10000000}
      closeIcon
      divLine={false}
      desktopWidth={'480px'}
    >
      <AlertModalContent
        title="We weren't able to decline your VIN marking service"
        icon={<CircleAlert size={24} color={icon.warning} />}
        action={
          <Button
            variant="primary"
            width="100%"
            onClick={onButtonClick}
            data-analytics-id="pp_SD_retry_decline_VIN_etching"
          >
            Try again
          </Button>
        }
      />
    </EventedModal>
  );
};
